import { Box } from "@mui/material";
import React, { useState } from "react";
import ReportType from "./ReportType";
import BasicInventory from "./BasicInventory";
import ComparisonByDate from "./ComparisonByDate";
import usePastStockCountsInfiniteScroll from "../../../../hooks/usePastStockCountsInfiniteScroll";

const reportTypeOptions = [
  { label: "Basic Inventory", value: 0 },
  { label: "Comparison By Date", value: 1 },
];

const StockCountReport = ({
  establishmentId,
  establishmentSettings,
  subscriptionState,
  setAlertSuccess,
  setErrorMessage
}) => {
  const [reportType, setReportType] = useState(reportTypeOptions[0]);
  const [page, setPage] = useState(1);
  const {
    isLoading: isLoadingPastStockCounts,
    //isError: isErrorLoadingPastStockCounts,
    data: pastStockCountData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = usePastStockCountsInfiniteScroll(
    establishmentId,
    page,
    subscriptionState?.isActive && establishmentId != undefined
  );

  return (
    <>
      <Box>
        <Box>
          <ReportType
            reportType={reportType}
            setReportType={setReportType}
            reportTypeOptions={reportTypeOptions}
          />
          <Box sx={{ marginTop: 4 }}>
            {reportType.value === 0 && (
              <BasicInventory
                establishmentId={establishmentId}
                subscriptionState={subscriptionState}
                isLoadingPastStockCounts={isLoadingPastStockCounts}
                pastStockCounts={pastStockCountData?.pages}
                setPage={setPage}
                fetchNextPage={fetchNextPage}
                hasNextPage={hasNextPage}
                isFetchingNextPage={isFetchingNextPage}
                setAlertSuccess={setAlertSuccess}
                setErrorMessage={setErrorMessage}
              />
            )}
            {reportType.value === 1 && (
              <ComparisonByDate
                establishmentId={establishmentId}
                establishmentTimezone={establishmentSettings?.inventorySettings?.timeZone}
                setAlertSuccess={setAlertSuccess}
                setErrorMessage={setErrorMessage}
              />
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default StockCountReport;
